import React from "react";
import Grid from "material-ui/Grid";
import Paper from "material-ui/Paper";
import ReactTable from "react-table";
import Typography from "material-ui/Typography";
import { Redirect } from "react-router-dom";
import SummaryCard from "./../../components/SummaryCard/SummaryCard";
import LinearLoader from "./../../components/LinearLoader/LinearLoader";
import UnitsTable from "./../../components/UnitsTable/UnitsTable";
import DatetimePicker from "./../../components/DatetimePicker/DatetimePicker";
import GrowTransition from "./../../components/GrowTransition/GrowTransition";

import Sequence from "./../../utilities/sequence";
import SummaryTripsImage from "./../../images/driving/summary-trips.png";
import SummarySpeedImage from "./../../images/driving/summary-speed.png";
import StartImage from "./../../images/start-marker.png";
import EndImage from "./../../images/end-marker.png";
import FetchButton from "../../components/FetchButton/FetchButton";
import DownloadAs from "../../components/DownloadAs/DownloadAs";
import "react-table/react-table.css";
import "./LlantasPro.css";
import { buildAnalysisByUnitColumns, buildEventsColumns } from "./builders";

const LlantasProView = props => {
  const {
    lang,
    units,
    permissions,
    isLoading,
    loadedPermissions,
    hasData,
    downloadExcel,
    downloadPDF,
    fetchLlantasProData,
    distanceUnit,
    behavior,
    events,
    analysisByUnit
  } = props;

  let analysisByUnitColumns = [];
  let eventsColumns = [];
  if (hasData) {
    analysisByUnitColumns = buildAnalysisByUnitColumns(lang);
    eventsColumns = buildEventsColumns(lang);
  }

  const fechaPrimerUbicacion = ["2018/01/29", "08:07:19"];
  const fechaUltimaUbicacion = ["2018/01/29", "08:13:34"];

  const sequence = new Sequence(0, 50);
  const duration = 50;

  return (
    <div className="llantas-pro">
      {loadedPermissions && !permissions.Fuel && <Redirect to={"./"} push />}

      {isLoading && <LinearLoader />}

      <div className="root">
        <Grid container spacing={24}>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className="grid-item"
          >
            <DownloadAs
              disabled={!(hasData && !isLoading)}
              xls={true}
              pdf={true}
              xlsClick={downloadExcel}
              pdfClick={downloadPDF}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className="grid-item"
          >
            <UnitsTable units={units} />
          </Grid>
        </Grid>
      </div>

      <div className="root">
        <Grid container spacing={24}>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className="grid-item"
          >
            <Paper className="margin-top-bottom rounded" elevation={4}>
              <Grid container spacing={24}>
                <Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
                  <DatetimePicker />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <div className="fetch-button-container">
                    <FetchButton
                      disabled={isLoading}
                      onClick={fetchLlantasProData}
                      text={lang.Consultar}
                    />
                  </div>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </div>

      {hasData && (
        <div className="root">
          <Grid container spacing={24}>
            <Grid
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              item
              className="grid-item"
            >
              <Typography
                variant="headline"
                align="center"
                color="primary"
                className="headline"
              >
                {lang.Resumen}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="grid-item"
            >
              <GrowTransition
                in={!isLoading}
                delay={sequence.next()}
                duration={duration}
              >
                <Paper className="summary rounded" elevation={4}>
                  <Grid container spacing={8}>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={3}
                      lg={3}
                      xl={3}
                      className="grid-item"
                    >
                      <SummaryCard
                        title={lang.Inicio}
                        value={fechaPrimerUbicacion[0]}
                        units={fechaPrimerUbicacion[1]}
                        imageUrl={StartImage}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={3}
                      lg={3}
                      xl={3}
                      className="grid-item"
                    >
                      <SummaryCard
                        title={lang.Fin}
                        value={fechaUltimaUbicacion[0]}
                        units={fechaUltimaUbicacion[1]}
                        imageUrl={EndImage}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={3}
                      lg={3}
                      xl={3}
                      className="grid-item"
                    >
                      <SummaryCard
                        title={lang.VelocidadMaxima}
                        value={behavior.VelocidadMaxima}
                        units={`${distanceUnit}/h`}
                        imageUrl={SummarySpeedImage}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={3}
                      lg={3}
                      xl={3}
                      className="grid-item"
                    >
                      <SummaryCard
                        title={lang.DistanciaRecorrida}
                        value={behavior.DistanciaRecorrida}
                        units={distanceUnit}
                        imageUrl={SummaryTripsImage}
                      />
                    </Grid>
                  </Grid>
                </Paper>
              </GrowTransition>
            </Grid>

            <GrowTransition
              in={!isLoading}
              delay={sequence.next()}
              duration={duration}
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className="grid-item headline"
              >
                <Typography variant="headline" align="left" color="primary">
                  {lang.Eventos}
                </Typography>
              </Grid>
            </GrowTransition>

            <GrowTransition
              in={!isLoading}
              delay={sequence.next()}
              duration={duration}
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className="grid-item"
              >
                <ReactTable
                  data={events}
                  columns={eventsColumns}
                  defaultPageSize={events.length < 5 ? events.length : 5}
                  filterable={true}
                  sortable={true}
                  previousText={lang.Anterior}
                  nextText={lang.Siguiente}
                  loadingText={`${lang.Cargando}...`}
                  noDataText={lang.NoSeEncontraronResultados}
                  pageText={lang.Pagina}
                  ofText={lang.De}
                  rowsText={lang.Resultados}
                  className="-striped -highlight borderless"
                />
              </Grid>
            </GrowTransition>

            <GrowTransition
              in={!isLoading}
              delay={sequence.next()}
              duration={duration}
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className="grid-item"
              >
                <Typography
                  className="headline"
                  variant="headline"
                  align="left"
                  color="primary"
                >
                  {lang.DescripcionPorUnidad}
                </Typography>
              </Grid>
            </GrowTransition>

            <GrowTransition
              in={!isLoading}
              delay={sequence.next()}
              duration={duration}
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className="grid-item"
              >
                <ReactTable
                  data={analysisByUnit}
                  columns={analysisByUnitColumns}
                  defaultPageSize={
                    analysisByUnit.length < 5 ? analysisByUnit.length : 5
                  }
                  filterable={true}
                  sortable={true}
                  previousText={lang.Anterior}
                  nextText={lang.Siguiente}
                  loadingText={`${lang.Cargando}...`}
                  noDataText={lang.NoSeEncontraronResultados}
                  pageText={lang.Pagina}
                  ofText={lang.De}
                  rowsText={lang.Resultados}
                  className="-striped -highlight borderless"
                />
              </Grid>
            </GrowTransition>
          </Grid>
        </div>
      )}
    </div>
  );
};

export default LlantasProView;



// WEBPACK FOOTER //
// ./src/containers/LlantasPro/LlantasProView.js